import ReactDOM from 'react-dom';
import App from './Pages/App';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
